import React from "react";

export default function TransactionList({ items, showReceipt }) {
  const base =
    import.meta.env.NODE_ENV === "production" ? "" : "http://localhost:5000";

  return (
    <div>
      {items.map((t) => (
        <div key={t._id}>
          <p>Name: {t.name}</p>
          <p>Comment: {t.comment}</p>
          <p>Type: {t.type}</p>
          <p>Amount: {t.amount}</p>
          <p>Date: {new Date(t.date).toLocaleDateString()}</p>
          {showReceipt && t.receiptUrl && (
            <img src={base + t.receiptUrl} alt="receipt" width="100" />
          )}

          {t.receiptUrl === "" ? (
            ""
          ) : (
            <p style={{ background: "yellow" }}>
              Url:{" "}
              <a
                href={base + t.receiptUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {base + t.receiptUrl}
              </a>{" "}
            </p>
          )}

          <hr
            style={{
              color: "red",
              backgroundColor: "red",
              height: "2px",
              border: "none",
            }}
          />
        </div>
      ))}
    </div>
  );
}
